export const colors = ["Black", "Space Gray", "Silver", "White", "Rose Gold", "Gold", "Midnight Blue", "Starlight"];
